module.exports = __webpack_public_path__ + "static/media/logo.98bf00fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Layout/logo.svg
// module id = 470
// module chunks = 0